<template>
  <span>
    <form class="row px-0 mx-0">
      <div class="col-6 mb-4">
        <div class="form-group">
          <label for="firstName" class="mb-2 d-block">Nombre</label>
          <input type="text" class="form-control" :value="perfil.nombre" disabled />
        </div>
      </div>
      <div class="col-6 mb-4">
        <div class="form-group">
          <label for="lastName" class="mb-2 d-block">Apellido</label>
          <input type="text" class="form-control" :value="perfil.apellido" disabled />
        </div>
      </div>
      <div class="col-6 mb-5">
        <div class="form-group">
          <label for="exampleInputEmail1" class="mb-2 d-block">Teléfono</label>
          <input type="text" class="form-control" :value="perfil.telefono" disabled />
          <!-- <small class="form-text text-muted">*verification purpose</small> -->
        </div>
      </div>
      <div class="col-6 mb-5">
        <div class="form-group">
          <label for="phone" class="mb-2 d-block">Url Avatar</label>
          <input type="text" class="form-control" :value="perfil.avatar" disabled />
          <!-- <small class="form-text text-muted">*verification purpose</small> -->
        </div>
      </div>
      <div class="col-6 mb-5">
        <div class="form-group">
          <label for="phone" class="mb-2 d-block">Store</label>
          <input
            type="text"
            class="form-control"
            :value="perfil.store === 1 ? 'Sendi' : 'Envios'"
            disabled
          />
          <!-- <small class="form-text text-muted">*verification purpose</small> -->
        </div>
      </div>
    </form>

    <div class="">
      <div>
        <h5 class="bold mb-2">Dirección de facturación</h5>
        <form class="row px-0 mx-0">
          <div class="col-6 mb-4">
            <div class="form-group">
              <label for="firstName" class="mb-2 d-block">Dirección</label>
              <input
                type="text"
                class="form-control"
                :value="direction.direction"
                disabled
              />
            </div>
          </div>
          <div class="col-6 mb-4">
            <div class="form-group">
              <label for="lastName" class="mb-2 d-block">Piso</label>
              <input type="text" class="form-control" :value="direction.piso" disabled />
            </div>
          </div>
          <div class="col-6 mb-5">
            <div class="form-group">
              <label for="exampleInputEmail1" class="mb-2 d-block">Referencia</label>
              <input
                type="text"
                class="form-control"
                :value="direction.referencia"
                disabled
              />
              <!-- <small class="form-text text-muted">*verification purpose</small> -->
            </div>
          </div>
          <div class="col-6 mb-5">
            <div class="form-group">
              <label for="phone" class="mb-2 d-block">Departamento</label>
              <input
                type="text"
                class="form-control"
                :value="direction.departamento"
                disabled
              />
              <!-- <small class="form-text text-muted">*verification purpose</small> -->
            </div>
          </div>
          <div class="col-6 mb-5">
            <div class="form-group">
              <label for="phone" class="mb-2 d-block">Provincia</label>
              <input
                type="text"
                class="form-control"
                :value="direction.provincia"
                disabled
              />
              <!-- <small class="form-text text-muted">*verification purpose</small> -->
            </div>
          </div>
          <div class="col-6 mb-5">
            <div class="form-group">
              <label for="phone" class="mb-2 d-block">Distrito</label>
              <input
                type="text"
                class="form-control"
                :value="direction.distrito"
                disabled
              />
              <!-- <small class="form-text text-muted">*verification purpose</small> -->
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- <button type="submit" class="btn btn-primary col-6 mx-auto mb-5">
      Save your changes
    </button> -->
    <div class="pt-0 d-flex justify-content-between align-items-center">
      <div>
        <h5 class="bold mb-2">Delete Your Account</h5>
        <p class="m-0 text-muted">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit <br />
          ut aliquam, purus sit amet luctus venenatis, lectus <br />
          magna fringilla urna, porttitor
        </p>
      </div>
      <button @click.prevent="getDeleteUser" type="button" class="btn btn-danger">
        Eliminar usuario
      </button>
    </div>
  </span>
</template>
<script>
import axios from "axios";
export default {
  props: ["perfil", "direction", "idUser"],
  data() {
    return {};
  },
  methods: {
    getDeleteUser() {
      this.is_loading = true;
      var answer = window.confirm(
        "Deseas eliminar al usuario?,se borrara todo vinculado a esta cuenta"
      );
      if (answer) {
        let url = process.env.API_URL + "/api/client/" + this.idUser + "/delete";
        axios
          .delete(url, { params: { hard: true } })
          .then(() => {
            this.is_loading = false;
            this.$router.push({
              name: "Users",
            });
          })
          .catch((error) => {
            // Verificar si hay respuesta en error.response
            const errorMessage = error.response && error.response.data.title 
                                ? error.response.data.title 
                                : 'No se pudo eliminar al usuario'; // Usar el title en el error
            alert("Error: " + errorMessage); // Mostrar el title del error en el alert
            this.is_loading = false;
            return;
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// PerfilComponent.vue?439c3c18